module.exports = __webpack_public_path__ + "img/ec-line005-line-guild-arrow.470932b0.svg";